/**
 * What each shelf looks like in the rail.
 *
 * Kept apart from `lib.ts` because that file is React-free and testable, and an
 * icon import would drag lucide into the test run for nothing.
 */
import { BookOpen, Brush, Code2, LifeBuoy, PenLine, Search, type LucideIcon } from "lucide-react";
import type { KbCategory } from "../../../lib/kb";

export const KB_CATEGORY_META: Record<KbCategory, { icon: LucideIcon; labelKey: string }> = {
  process: { icon: BookOpen, labelKey: "kb.category.process" },
  web: { icon: Code2, labelKey: "kb.category.web" },
  design: { icon: Brush, labelKey: "kb.category.design" },
  content: { icon: PenLine, labelKey: "kb.category.content" },
  seo: { icon: Search, labelKey: "kb.category.seo" },
  care: { icon: LifeBuoy, labelKey: "kb.category.care" },
};
